const FolderIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M0 5.99368V11.9997C0.00221875 13.8397 1.49331 15.3308 3.33334 15.333H12.6667C14.5067 15.3308 15.9978 13.8397 16 11.9997V5.91968L0 5.99368Z"
        fill="#052351"
      />
      <path
        d="M12.6667 2.00006H8.31466C8.21156 2.00075 8.10966 1.97794 8.01666 1.9334L5.91266 0.877404C5.63491 0.739092 5.32894 0.666998 5.01866 0.666748H3.33331C1.49331 0.668936 0.00221875 2.16003 0 4.00006V4.66072L15.9087 4.58672C15.5613 3.07531 14.2175 2.00315 12.6667 2.00006Z"
        fill="#052351"
      />
    </svg>
  )
}

export default FolderIcon
